(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["joffz-collection-overlay-guard"] && !Shopify.designMode) return;
  try {
    (() => {
 const init = () => {
  const areas = [...document.querySelectorAll('.joffz-collection-hero, .joffz-collection-editorial, #product-grid h3, footer')];
  const giftHeading = document.querySelector('[id^="GiftCardFooterHeading-"]');
  if (giftHeading) areas.push(giftHeading.closest('section') || giftHeading.parentElement);
  if (!areas.length || !('IntersectionObserver' in window)) return;
  const visible = new Set();
  const observer = new IntersectionObserver(entries => {
   entries.forEach(entry => entry.isIntersecting ? visible.add(entry.target) : visible.delete(entry.target));
   document.body.classList.toggle('joffz-collection-reading', visible.size > 0);
  });
  areas.forEach(area => observer.observe(area));
 };
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
 else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["joffz-journal-scripts"] && !Shopify.designMode) return;
  try {
    (() => {
  'use strict';

  const pushEvent = (event, detail = {}) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...detail });
  };

  const slugify = (text) => {
    return text
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '') || 'section';
  };

  const ensureUniqueId = (heading, usedIds) => {
    const base = heading.id || slugify(heading.textContent.trim());
    let id = base;
    let index = 2;

    while (usedIds.has(id) || document.getElementById(id)) {
      if (heading.id === id) break;
      id = `${base}-${index}`;
      index += 1;
    }

    usedIds.add(id);
    heading.id = id;
    return id;
  };

  const buildToc = (root) => {
    const readingMain = root.querySelector('.jz-article-main');
    if (!readingMain) return [];

    const headings = Array.from(readingMain.querySelectorAll('h2')).filter((heading) => {
      return heading.textContent.trim().length > 0 && !heading.closest('[data-jz-ignore-toc]');
    });

    const desktopList = root.querySelector('[data-jz-toc]');
    const mobileList = root.querySelector('[data-jz-toc-mobile]');
    const usedIds = new Set();

    const items = headings.map((heading) => {
      const id = ensureUniqueId(heading, usedIds);
      const label = heading.textContent.trim();
      return { heading, id, label };
    });

    const renderList = (list) => {
      if (!list) return;
      list.textContent = '';

      items.forEach(({ id, label }) => {
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = `#${id}`;
        link.textContent = label;
        link.dataset.jzTocLink = id;
        item.appendChild(link);
        list.appendChild(item);
      });

      if (!items.length) {
        list.closest('.jz-toc')?.setAttribute('hidden', '');
      }
    };

    renderList(desktopList);
    renderList(mobileList);

    root.querySelectorAll('[data-jz-toc-link]').forEach((link) => {
      link.addEventListener('click', () => {
        pushEvent('journal_toc_click', {
          article_title: document.querySelector('.jz-article-hero h1')?.textContent.trim() || '',
          section_name: link.textContent.trim()
        });
      });
    });

    return items;
  };

  const setActiveToc = (root, items) => {
    if (!items.length || !('IntersectionObserver' in window)) return;

    const activate = (id) => {
      root.querySelectorAll('[data-jz-toc-link]').forEach((link) => {
        const isActive = link.dataset.jzTocLink === id;
        link.classList.toggle('is-active', isActive);
        if (isActive) link.setAttribute('aria-current', 'location');
        else link.removeAttribute('aria-current');
      });
    };

    const observer = new IntersectionObserver((entries) => {
      const visible = entries
        .filter((entry) => entry.isIntersecting)
        .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);

      if (visible.length) activate(visible[0].target.id);
    }, {
      rootMargin: '-18% 0px -68% 0px',
      threshold: [0, 1]
    });

    items.forEach(({ heading }) => observer.observe(heading));
  };

  const initProgress = (root) => {
    const bar = root.querySelector('[data-jz-progress]');
    const zone = root.querySelector('[data-jz-reading-zone]');
    if (!bar || !zone) return;

    let ticking = false;
    const update = () => {
      const start = zone.getBoundingClientRect().top + window.scrollY;
      const end = start + zone.offsetHeight - window.innerHeight;
      const distance = Math.max(1, end - start);
      const progress = Math.min(1, Math.max(0, (window.scrollY - start) / distance));
      bar.style.transform = `scaleX(${progress})`;
      ticking = false;
    };

    const requestUpdate = () => {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    };

    update();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate, { passive: true });
  };

  const initScrollTracking = (root) => {
    const zone = root.querySelector('[data-jz-reading-zone]');
    if (!zone) return;

    const sent = new Set();
    const thresholds = [25, 50, 75, 90];
    const articleTitle = root.querySelector('.jz-article-hero h1')?.textContent.trim() || '';

    const check = () => {
      const start = zone.getBoundingClientRect().top + window.scrollY;
      const end = start + zone.offsetHeight - window.innerHeight;
      const distance = Math.max(1, end - start);
      const percent = Math.max(0, Math.min(100, ((window.scrollY - start) / distance) * 100));

      thresholds.forEach((threshold) => {
        if (percent >= threshold && !sent.has(threshold)) {
          sent.add(threshold);
          pushEvent(`journal_scroll_${threshold}`, {
            article_title: articleTitle,
            scroll_percent: threshold
          });
        }
      });
    };

    window.addEventListener('scroll', check, { passive: true });
    check();
  };

  const initCopyLink = (root) => {
    root.querySelectorAll('[data-jz-copy-link]').forEach((button) => {
      button.addEventListener('click', async () => {
        const original = button.textContent;
        try {
          await navigator.clipboard.writeText(window.location.href);
          button.textContent = 'Link copied';
          pushEvent('journal_share_click', { share_channel: 'copy_link' });
        } catch (error) {
          const input = document.createElement('input');
          input.value = window.location.href;
          document.body.appendChild(input);
          input.select();
          document.execCommand('copy');
          input.remove();
          button.textContent = 'Link copied';
        }
        window.setTimeout(() => { button.textContent = original; }, 1800);
      });
    });
  };

  const initArticle = (root) => {
    const title = root.querySelector('.jz-article-hero h1')?.textContent.trim() || '';
    pushEvent('journal_article_view', { article_title: title });
    const tocItems = buildToc(root);
    setActiveToc(root, tocItems);
    initProgress(root);
    initScrollTracking(root);
    initCopyLink(root);
  };

  const initClickTracking = () => {
    document.addEventListener('click', (event) => {
      const productLink = event.target.closest('[data-jz-product-link]');
      if (productLink) {
        pushEvent('journal_product_click', {
          product_title: productLink.querySelector('h3')?.textContent.trim() || '',
          destination: productLink.href
        });
      }

      const collectionLink = event.target.closest('[data-jz-collection-link]');
      if (collectionLink) {
        pushEvent('journal_collection_click', {
          destination: collectionLink.href
        });
      }

      const relatedLink = event.target.closest('[data-jz-related-article]');
      if (relatedLink) {
        pushEvent('journal_related_article_click', {
          article_title: relatedLink.querySelector('.jz-card__title')?.textContent.trim() || '',
          destination: relatedLink.href
        });
      }

      const shareLink = event.target.closest('.jz-share a');
      if (shareLink) {
        pushEvent('journal_share_click', {
          share_channel: shareLink.getAttribute('aria-label') || shareLink.textContent.trim()
        });
      }
    });

    document.querySelectorAll('.jz-newsletter__form').forEach((form) => {
      form.addEventListener('submit', () => pushEvent('journal_newsletter_submit'));
    });
  };

  const init = () => {
    document.querySelectorAll('[data-jz-article-root]').forEach(initArticle);
    initClickTracking();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
